import { ResolveFn } from '@angular/router';
import {
  APPOINTMENT_DETAILS_API_ACTIONS,
  CAMPAIGN_DETAILS_API_ACTIONS,
  CONVERSATION_DETAILS_API_ACTIONS,
  LEASING_PREFERENCES_API_ACTIONS,
  TAGS_API_ACTIONS,
} from '../../store/actions';
import { inject } from '@angular/core';
import { Store } from '@ngrx/store';

export const conversationDataResolver: ResolveFn<boolean> = () => {
  const store = inject(Store);

  store.dispatch(TAGS_API_ACTIONS.get());
  store.dispatch(CONVERSATION_DETAILS_API_ACTIONS.get());
  store.dispatch(LEASING_PREFERENCES_API_ACTIONS.get());
  store.dispatch(APPOINTMENT_DETAILS_API_ACTIONS.get());
  store.dispatch(CAMPAIGN_DETAILS_API_ACTIONS.get());

  return true;
};
